import { Chip } from '../../../atoms/Chip';
import { ProgressBar } from '../../../atoms/ProgressBar';
import { Typography } from '../../../molecules/Typography';
import { useScheduleSlotContext } from '../useScheduleSlotContext';

export interface IScheduleSlotProgressProps {
  type: 'discipline' | 'simulated' | 'essay';
  progressType: 'number' | 'time' | 'text';
  progressBarColor?: string;
  progressBarBackgroundColor?: string;
  customText?: string;
}

export function ScheduleSlotProgress({
  type,
  progressType,
  progressBarColor,
  progressBarBackgroundColor,
}: IScheduleSlotProgressProps) {
  const {
    selected,
    currentProgress,
    totalProgress,
    type: slotType,
  } = useScheduleSlotContext();

  const isCompleted = currentProgress >= totalProgress;

  function getProgressPercentage() {
    return (currentProgress / totalProgress) * 100;
  }

  const progressText =
    progressType === 'time'
      ? `${getProgressPercentage().toFixed(0)}% concluída`
      : `${currentProgress}/${totalProgress}`;

  if (type === 'essay') {
    return (
      <div className={'flex items-center justify-between gap-sm'}>
        {isCompleted ? (
          <Chip
            size={'sm'}
            className={'border-none bg-feedback-color-success-pure'}
          >
            Concluído
          </Chip>
        ) : (
          <ProgressBar
            color={progressBarColor}
            backgroundColor={progressBarBackgroundColor}
            progress={getProgressPercentage()}
          />
        )}
        <Typography
          size={'mini'}
          className={`min-w-fit ${selected ? 'text-mono-color-white' : ''}`}
        >
          {progressText}
        </Typography>
      </div>
    );
  }

  return (
    <div className={'flex items-center justify-between gap-sm'}>
      {isCompleted && slotType === 'default' ? (
        <Chip
          size={'sm'}
          className={'border-none bg-feedback-color-success-pure'}
        >
          Concluído
        </Chip>
      ) : (
        <ProgressBar
          color={progressBarColor}
          backgroundColor={progressBarBackgroundColor}
          progress={getProgressPercentage()}
        />
      )}

      {slotType === 'default' && (
        <Typography
          size={'mini'}
          className={`min-w-fit ${selected && type !== 'simulated' ? 'text-mono-color-white' : ''}`}
        >
          {progressText}
        </Typography>
      )}
    </div>
  );
}
